// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__KL_nI","empty":"ModalGraph_empty__2jrd-"};